export default __webpack_public_path__ + "media/images/front/about/youtube-366d4963e077ce968b130cdc527ff4aa.png";